export const CardViewEnum = {
  COMPACT: 'compact',
  NORMAL: 'normal',
  EXPANDED: 'expanded',
} as const;
export type CardViewEnum = (typeof CardViewEnum)[keyof typeof CardViewEnum];

export const NEW_CARD = 'NEW_CARD';
export const UPDATED_CARD = 'UPDATED_CARD';
